<div class="container">
  <app-header></app-header>

  <div class="body">
    <app-title (clickClose)="handleClose()"></app-title>
    <div class="payment-container">
      <div class="top-section">
        <img src="assets/pix-payment.svg" alt="">
        <h3>Aguardando pagamento</h3>
        <div class="warning-banner">
          <mnt-icon
            icon="signalingWarningTriangle"
            size="medium"
            color="#9D670B"
            background="signalingWarningTriangle"
          ></mnt-icon>
          <span><strong>Atenção:</strong> Após pagar, volte e aguarde a confirmação nesta tela.</span>
        </div>
      </div>
      <div class="bottom-section">
        @if (showQrCode) {
          <div class="qr-wrapper">
            <span class="qr-amount">{{ amountToPay | currency }}</span>
            <canvas id="pix-qrcode"></canvas>
          </div>
        } @else {
          <input type="text" readonly [value]="qrCode">
          <yoo-icon icon="copy" size="medium" (click)="handleCopyQrCode()"></yoo-icon>
        }
      </div>
      <p>Você pode pagar em até <b>{{ timeLabel }}</b></p>
    </div>
  </div>
</div>
